// --------------------------------------------------------
// PhotoUser - PhotoUser
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { CircularProgress } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import { useCallback, useEffect, useState } from "react";
import { PersonService } from "../../core/http/service/PersonService";
import { UserService } from "../../core/http/service/UserService";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// PhotoUser INTERFACE
// --------------------------------------------------------

interface IPhotoUser {
  isFetchingPhoto: boolean;
  setIsFetchingPhoto: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const PhotoUser = ({ isFetchingPhoto, setIsFetchingPhoto }: IPhotoUser) => {
  // --------------------------------------------------------
  // PhotoUser PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const [photo, setPhoto] = useState("");
  const [isLoading, setLoading] = useState(true);

  const fetchPhoto = useCallback(async () => {
    setIsFetchingPhoto(true);
    const service: UserService = new UserService();
    const servicePerson: PersonService = new PersonService();
    try {
      const userInfoResponse: any = await service.getInfo();
      const userInfo = userInfoResponse.data.data;

      if (userInfo.foto !== null) {
        const photoUser: any = await servicePerson.getPhoto(userInfo.foto);

        const blob = new Blob([photoUser.data], {
          type: photoUser.headers["content-type"],
        });

        const image = URL.createObjectURL(blob);

        setPhoto(image);
      }
    } catch (error: any) {
      console.error("Erro ao buscar foto do usuário:", error);
    } finally {
      setIsFetchingPhoto(false);
      setLoading(false);
    }
  }, [setIsFetchingPhoto]);

  useEffect(() => {
    fetchPhoto();
  }, [fetchPhoto]);

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      {isLoading ? (
        <div style={{ textAlign: "center", height: "60px", width: "60px" }}>
          <CircularProgress />
        </div>
      ) : (
        <Avatar
          style={{ height: "60px", width: "60px" }}
          src={photo}
          alt="FotoUser"
        />
      )}
    </>
  );
  // --------------------------------------------------------
};

export default PhotoUser;
